module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-forward-fill-3dfd950f.svg";